// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"65e9eede","213":"f4922352","483":"3e5f3847","549":"6116e520","766":"c31e682d"}[chunkId] + ".chunk.js";
};